import React, { useState }  from 'react';
import { useSelector }      from 'react-redux';
import { Modal }            from 'react-bootstrap';
import { chains, findByChainId }    from 'helpers/EthereumContext';


const HEADER    = 'METAMASK Info'
const TITLE     = 'Adding Networks and Currency'

function alAppend(actionsList, chain){
    actionsList.push({
        message: `Add - ${chain.displayName} network`,
        messag2: `+ QUDO currency`
    })
}

// show             -   useState[0]
// onHide           -   ()=>{useState[1](false)}
// currChainId      -   chain.chainId
export default function AddingNetworksModal(props) {
    
    const actionsList = []
    for(const Ichain in chains){const chain = chains[Ichain]
        if( chain.chainId === props.currChainId )
            continue
        alAppend(actionsList, chain)
    }

    if( props.currChainId ){
        const chain = findByChainId(props.currChainId)
        if( chain ){
            alAppend(actionsList, chain)
        }
    }

    return(
<Modal 
    show={props.show}
    onHide={props.onHide}>
<Modal.Header >
    <div className='w-100 text-center' id='title' style={{fontSize:'1.5rem'}} >
        {HEADER}
    </div>
</Modal.Header>
<Modal.Body className="confirm-modal">
    <div style={{padding: "2rem 4rem"}}>
    <div className="confirm-modal-text text-center">
        <div>
            <div style={{marginBottom:'8px'}}>
                <h3 key={'AddNetworkTITLE'} style={{textAlign:'left'}}>{TITLE}</h3>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    gap:'1rem',
                    borderTop:'1px solid black',
                    padding:'16px 4px 8px',
                }}>
                { actionsList.map(( a, i ) => {
                    if(!a.message || a.message.trim() === '')
                        return null

                    return(<div>
                        <div key={`${a.func}-${i}`} style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                        }} >
                            <div> 
                                {a.message}
                            </div>
                            <div style={{padding:'0 32px'}}>
                                {a.messag2}
                            </div>
                        </div>
                        {a.error && a.error.trim() !== '' && 
                        <div style={{
                            fontWeight:'lighter',
                            color:'red',
                            float:'left',
                        }}>
                            {a.error}
                        </div>
                        }
                    </div>) }) } 
                </div>
            </div>
            
            <div style={{
                display:'flex',
                justifyContent:'flex-end',
                gap: '16px',
            }}>
                <button 
                    type="button"
                    className="std-button-active-blue transfer-modal-action-buttons"
                    onClick={()=>{props.onHide()}}
                >
                    Close
                </button>
            </div>

        </div>
    </div>
    </div>
</Modal.Body>
</Modal>
    )
}
